import * as types from './mutation-types'
import cookies from 'cookiesjs'
import Vue from 'vue'

const disconnectFromWebSocket = () => {
  if (window.Echo != undefined) {
    if (window.Echo.hasOwnProperty('connector') && window.Echo.connector.hasOwnProperty('pusher')) {
      window.Echo.connector.pusher.disconnect()
    }

    window.Echo = undefined
  }
}

const updateStateAndCookieEmail = (state, email, remember) => {
    state.userEmail = email
    console.log('updating:', email, remember)
    remember && cookies({ defaultEmail: email })
    return state
}

const userDisconnected = (state) => {
    state.isLoggedIn = false
    return state
}

const checkFromRouteMeta = (state) => {
    const fromRoute = state.fromRoute
    if (!(_.isEmpty(fromRoute) && _.isEmpty(fromRoute.meta))) {
        state.fromRoute.meta = {}
    }
    return state
}

const mutations = {

    [types.LOGIN_SUCCESS](state, payload) {
        state.isLoggedIn = true

        const fromRoute = state.fromRoute
        if (!(_.isEmpty(fromRoute) && _.isEmpty(fromRoute.meta))) {
            state.fromRoute.meta = {}
        }

        const email = payload.email,
            remember = payload.rememberEmail
        state.userEmail = email
        console.log('updating:', email, remember)
        remember && cookies({ defaultEmail: email })
    },

    [types.LOGIN_FAILURE](state) {
        state.isLoggedIn = false
        // state.userEmail = null
    },

    [types.LOGOUT](state, tokenIsInvalid = false) {
        disconnectFromWebSocket()
        
        // saving last route restoring it back
        // if login will succeed
        let route = state.route,
            meta = { tokenIsInvalid }

        if (_.isEmpty(state.fromRoute)) {
            state.fromRoute = _.assign({}, route, { meta })
        }

        state.isLoggedIn = false
    },

    [types.FORM_RESET_AFTER](state) {
        state.resourceForm.uid = null
        state.resourceForm.resource = ''
        state.resourceForm.method = ''
    },

    [types.FORM_UID_CHANGED](state, uid) {
        state.resourceForm.uid = uid
    },

    [types.FORM_ERROR](state, response) {
        state.formError = response
    },

    [types.FORM_SUCCESS](state, payload) {
        state.resourceForm = _.assign({}, state.resourceForm, payload)
    },

    [types.DEFAULT_EMAIL](state, email) {
        state.userEmail = email
    },

    [types.FROM_ROUTE_RESTORED](state) {
        state.fromRoute = {}
    },

    [types.USER_APP_VISIBLILTY](state, value) {
        state.isVisible = value
    },

    [types.USER_APP_ACTIVITY](state, value) {
        state.isActive = value
    },

    [types.AGENCIES_RECEIVED](state, payload) {
        Vue.set(state, "agencies", payload)
    },

    [types.ORGANIZATIONS_RECEIVED](state, payload) {
        Vue.set(state, "organizations", payload)
    },
    
    [types.SAP_PROMO_CODES_RECEIVED](state, payload) {
        Vue.set(state, "sapPromoCodes", payload)
    }
}

export default mutations



// WEBPACK FOOTER //
// ./client/store/mutations.js